import { useQuery } from "@tanstack/vue-query";
import { type Ref } from "vue";
import { api } from "@/api";
import { type BaseReportFilters } from "./reports";

export const REPORT_OVERVIEW_QUERY_KEY = "overview-reports";

export type OverviewReportRow = {
  siteName: string;
  siteIsCompanion: boolean;
  totalArrivals: number;
  totalTouringArrivals: number;
  totalTouringExperienceFreedomArrivals: number;
  totalAnprArrivals: number;
  percentageAnprArrivals: string;
  totalReceptionArrivals: number;
  percentageReceptionArrivals: string;
  totalOutsideEntryTimeAttempts: number;
  percentageOutsideEntryTimeAttempts: string;
  totalSmsPitchDetails: number;
  percentageSmsPitchDetails: string;
  totalReceptionPitchDetails: number;
  percentageReceptionPitchDetails: string;
  totalFastCheckIn: number;
  percentageFastCheckIn: string;
  totalPaidInAdvance: number;
  percentagePaidInAdvance: string;
  totalBalanceDue: number;
  percentageBalanceDue: string;
  totalAbf: number;
  percentageAbf: string;
  totalCompanionEligible: number;
  totalCompanionUsed: number;
  percentageCompanionUsed: string;
};

export type OverviewReport = OverviewReportRow[];

export const retrieveOverviewReport = async (query: BaseReportFilters) => {
  const { body } = await api.get<OverviewReport>("/reports/overview/", {
    query: query,
  });

  return body;
};

export const useOverviewReport = (
  filters: BaseReportFilters | Ref<BaseReportFilters>,
) => {
  return useQuery({
    queryKey: [REPORT_OVERVIEW_QUERY_KEY, filters] as const,
    queryFn: ({ queryKey: [_, query] }) => retrieveOverviewReport(unref(query)),
    staleTime: 60 * 60 * 1000,
  });
};

export const exportOverviewReport = async (query: BaseReportFilters) => {
  const data = await api.get<Blob>("/reports/overview/export/", {
    query: query,
  });

  return exportFileFromRespone(data);
};
